.root {
	// The embed's panel geometry: inset from the frame edge, and the gap
	// between the query and result panels, which split the rest evenly.
	--mini-inset: 12px;
	--mini-gap: 8px;
	--mini-half: calc((100% - 2 * var(--mini-inset) - var(--mini-gap)) / 2);

	position: relative;
	margin-block: var(--mantine-spacing-xl);
	background: var(--docs-card);

	// The frame paints over the blocks behind it.
	> :last-child {
		position: relative;
	}

	// A transparent iframe is only see-through when its own colour scheme
	// matches the embedded document's; otherwise the browser paints an opaque
	// canvas, white, behind it. The embedded Surrealist page declares no colour
	// scheme, so it is `normal`, while the kit writes `color-scheme: dark` on the
	// frame inline - hence `!important` to put the frame back to `normal`.
	iframe {
		color-scheme: normal !important;
	}
}

// Behind each panel, the same colour as the panel with square corners.
.panel-backing {
	position: absolute;
	background: var(--surreal-paper-background);

	[data-orientation="vertical"] > & {
		left: var(--mini-inset);
		right: var(--mini-inset);
		height: var(--mini-half);

		&[data-panel="first"] {
			top: var(--mini-inset);
		}

		&[data-panel="second"] {
			bottom: var(--mini-inset);
		}
	}

	[data-orientation="horizontal"] > & {
		top: var(--mini-inset);
		bottom: var(--mini-inset);
		width: var(--mini-half);

		&[data-panel="first"] {
			left: var(--mini-inset);
		}

		&[data-panel="second"] {
			right: var(--mini-inset);
		}
	}
}

// Light mode draws the edge with a 1px line instead of a fill.
.root {
	@include light {
		border: 1px solid var(--surreal-border-default);
	}
}
